export const validateEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
};
export const US_PHONE_REGEX = /^(\+?[0-9\s().-]+)$/;

export const SPECIAL_CHAR_PATTERN = /[^a-zA-Z0-9\s._-]/;
